import * as React from "react";
import type { SVGProps } from "react";
const MailboxPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M5 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm0 4h14v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm4 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V12H9z" clipRule="evenodd" /></svg>;
export default MailboxPanelIcon;